module.exports = __webpack_public_path__ + "static/media/campbells.66876713.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/campbells.png
// module id = 80
// module chunks = 0